module.exports = __webpack_public_path__ + "img/hand-credit-card.b20f7173.svg";